module.exports = __webpack_public_path__ + "static/media/rng-6.1c6a3cd4.gif";